import { render, staticRenderFns } from "./AddCardComponent.vue?vue&type=template&id=f36aa82c"
import script from "./AddCardComponent.vue?vue&type=script&lang=js"
export * from "./AddCardComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports